import { render } from "./QuitButton.vue?vue&type=template&id=13b97146&scoped=true"
import script from "./QuitButton.vue?vue&type=script&lang=js"
export * from "./QuitButton.vue?vue&type=script&lang=js"

import "./QuitButton.vue?vue&type=style&index=0&id=13b97146&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b97146"]])

export default __exports__